import AmberFinLogo from './img/AmberFinLogo.png';
import './App.css';
import {useState} from 'react';
import {Button, Col, Divider, Drawer, Grid, Menu, Row} from 'antd';
import ReactCountryFlag from "react-country-flag";
import {MenuOutlined} from "@ant-design/icons";
import {NavLink, useLocation, useNavigate} from "react-router-dom";

const { useBreakpoint } = Grid;

const menuItems = [
    { key: '/products', label: 'PRODUCTS' },
    { key: '/services', label: 'SERVICES' },
    { key: '/about', label: 'ABOUT' },
    { key: '/contacts', label: 'CONTACTS' },
    { type: 'divider' },
    { key: '/register', label: 'Register' },
    { key: '/login', label: 'Login' },
];

function Header() {
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <>
            <Row style={{maxWidth: 1024, margin: '12px auto', padding: 12}} className={'header'} align={'middle'}>
                <Col
                    xs={20}
                    sm={20}
                    md={12}
                    lg={12}
                    style={{display: 'flex', alignItems: 'center'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <NavLink to={'/'}>
                        <img
                            src={AmberFinLogo}
                            style={{maxWidth: '32px', marginRight: 18}}
                         alt={'Amber Information Technologies Logo'}/>
                        </NavLink>
                        <span className={"amber-title-color"} style={{fontSize: 12}}>
                            <NavLink className={"amber-title-color"} to={'/'}>
                                <strong>AMBER</strong>TECHNOLOGIES
                            </NavLink>
                      </span>
                    </div>
                </Col>
                <Col
                    xs={4}
                    sm={4}
                    md={12}
                    lg={12}
                    style={{textAlign: "right"}}>
                    {isMobile ? (
                        <Button
                            type={'text'}
                            icon={<MenuOutlined/>}
                            aria-label={'Open menu'}
                            onClick={() => setOpen(true)}
                        />
                    ) : (
                        <>
                            <div>
                                <ReactCountryFlag
                                    countryCode="LT"
                                    svg
                                    style={{
                                        width: '1em',
                                        height: '1em',
                                    }}
                                    title="Lithuania"
                                />

                                <NavLink className={"menu"} style={{marginLeft: 12}} to={'/register'} >
                                    Register
                                </NavLink>
                                <NavLink className={"menu"} to={'/login'}>
                                    <Button style={{marginLeft: 12, fontSize: 12, color: '#513f38'}}>
                                        Login
                                    </Button>
                                </NavLink>
                            </div>

                            <div className={"top-menu"} style={{paddingTop: 24,}}>
                                <NavLink className={"menu"} to={'/products'}>
                                    PRODUCTS
                                </NavLink>
                                <NavLink className={"menu"} to={'/services'} >
                                    SERVICES
                                </NavLink>
                                <NavLink className={"menu"} to={'/about'} >
                                    ABOUT
                                </NavLink>
                                <NavLink className={"menu"} to={'/contacts'} >
                                    CONTACTS
                                </NavLink>
                            </div>
                        </>
                    )}
                </Col>
            </Row>
            <Drawer
                title={<span className={"amber-title-color"} style={{fontSize: 12}}><strong>AMBER</strong>TECHNOLOGIES</span>}
                placement={'right'}
                size={260}
                open={isMobile && open}
                onClose={() => setOpen(false)}
            >
                <Menu
                    mode={'vertical'}
                    selectable={false}
                    items={menuItems.map((item) => (
                        item.key === location.pathname ? {...item, disabled: true} : item
                    ))}
                    style={{borderInlineEnd: 'none'}}
                    onClick={({key}) => {
                        setOpen(false);
                        navigate(key);
                    }}
                />
            </Drawer>
    <Divider style={{margin: isMobile ? '0 0 16px 0' : undefined}}/>
        </>
    );
}

export default Header;
